import {
  Alert,
  AlertColor,
  Snackbar,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  BackButton,
  Button,
  CodeIcon,
  Container,
  Content,
  ContentBody,
  ContentInput,
  ContentInputProfilePhoto,
  ContentInputProfilePhotoIcon,
  ContentTitle,
  DeleteIcon,
  DeletePrompt,
  DeletePromptNo,
  DeletePromptYes,
  Icon,
  SoftwareIcon,
  Title,
  UsersIcon,
  Version,
  VersionContainer,
  VersionList,
  VersionRight,
  VersionTitle,
} from "./styles";
import { useParams } from "react-router-dom";
import CustomSelection, { valueProp } from "../../../Components/CustomSelection";
import { UserPermissions } from "../../../App";
import { ArrowBack, VpnKey } from "@mui/icons-material";
import ActivationCodesView from "../ActivationCode";

interface Props {
  userPermissions: UserPermissions;
}

interface SelectedVersion {
  type: string;
  version: string;
}

const ViewPatients: React.FC<Props> = ({ userPermissions }) => {
  const { softwareID } = useParams();
  // Activation Codes
  const [showActivationCodes, setShowActivationCodes] = useState(false);
  const [selectedVersion, setSelectedVersion] = useState<SelectedVersion>();

  // Ivan Implementation
  const [categories, setCategories] = React.useState<valueProp>([
    { label: "Balance", value: "Balance", checked: false },
    { label: "Cognition", value: "Cognition", checked: false },
    { label: "Upper Limb", value: "Upper Limb", checked: false },
    { label: "Mobility", value: "Mobility", checked: false },
    { label: "Fitness", value: "Fitness", checked: false },
  ]);
  const [software, setSoftware] = React.useState<{
    logo: string;
    name: string;
    id: string;
    description: string;
    owners: { id: string; type: "user" | "org" }[];
  }>({
    logo: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
    name: "Universal App Showcase",
    id: "com.zlynt.universal_app_demo",
    description: "",
    owners: [{ id: "Zlynt", type: "user" }],
  });

  const [owners, setOwners] = React.useState<valueProp>([
    //  { label: "ResearchX", type: 'user', value: 'research_x', checked: false } //Layout
  ]);
  const [editors, setEditors] = React.useState<valueProp>([]);
  const [versions, setVersions] = React.useState<
    Array<{
      description: string;
      type: string;
      version: string;
      allowedUsers: Array<string>;
      accessType: "Public" | "Owners" | "Restrict";
    }>
  >([]);

  const [deleteVersion, setDeleteVersion] = useState<number>();

  const [showStatus, setShowStatus] = React.useState(false);
  const [statusMsg, setStatusMsg] = React.useState("");
  const [statusSeverity, setStatusSeverity] =
    React.useState<AlertColor>("error");
  const handleCloseStatus = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setShowStatus(false);
  };

  const hiddenLogoInput = React.useRef<HTMLInputElement>(null);

  const onImageChangeClick = () => {
    if (hiddenLogoInput.current) {
      hiddenLogoInput.current.click();
    }
  };
  const onHiddenLogoInputChange = (event: any) => {
    const fileUploaded = event.target.files[0];

    var reader = new FileReader();
    var baseString;
    reader.onloadend = function () {
      baseString = reader.result;
      setSoftware({
        ...software,
        logo: baseString + "",
      });
    };
    reader.readAsDataURL(fileUploaded);
  };

  const changeVar = (varName: string, value: string) => {
    setSoftware({
      ...software,
      [varName]: value,
    });
    console.log(software);
  };

  const getSoftware = async () => {
    console.log("Current session permissions:", userPermissions);
    fetch("/api/v1/software/get", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: softwareID,
        receiveVersions: true,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data?.success === true) {
          delete data.success;
          setSoftware(data.software);

          console.log("Possible Owner list: ", data.software.owners);
          console.log("/api/v1/software/get :", data);
          setVersions(data.versions);
          const toSetOwners = data.software.owners.map((val: any) => {
            return {
              label: val.id,
              type: val.type,
              value: val.id,
              checked: true,
            };
          });
          setOwners(toSetOwners);
          const toSetEditors = data.software.editors.map((val: any) => {
            return {
              label: val.username,
              type: "user",
              value: val.username,
              checked: val.isAllowed,
            };
          });
          setEditors(toSetEditors);
          getPossibleOwnerList(toSetOwners);
          setCategories(
            categories.map((val: any) => {
              // { label: "Upper Limb", value: "Upper Limb", checked: false },
              return {
                ...val,
                checked: data.software.categories.includes(val.value),
              };
            })
          );
          //  { label: "ResearchX", type: 'user', value: 'research_x', checked: false } //Layout
        }
        console.log(data);
      });
  };
  const setSoftwareAccessType = async (
    _softwareID: string,
    _type: string,
    _version: string,
    _accessType: string
  ) => {
    console.log(
      `Setting access to following version: ${_softwareID}:${_type}:${_version}`
    );
    fetch("/api/v1/software/type/version/access/edit", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        software: _softwareID,
        type: _type,
        version: _version,
        accessType: _accessType,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.success === true) {
          setStatusMsg(
            `Access set to ${_accessType} for the version ${_version} (from type '${_type}') of this software!`
          );
          setStatusSeverity("success");
          setShowStatus(true);
          getSoftware();
          setTimeout(() => {
            setShowStatus(false);
          }, 5000);
          return data.success;
        } else {
          setStatusMsg(data.reason);
          setStatusSeverity("error");
          setShowStatus(true);
          setTimeout(() => {
            setShowStatus(false);
          }, 5000);
        }
      });
  };
  const addSoftwareVersionAccess = async (
    _softwareID: string,
    _type: string,
    _version: string,
    _username: string
  ) => {
    console.log(
      `Setting access to following version: ${_softwareID}:${_type}:${_version}`
    );
    fetch("/api/v1/software/type/version/access/add", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        software: _softwareID,
        type: _type,
        version: _version,
        username: _username,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.success === true) {
          setStatusMsg(
            `Access given to user ${_username} for the version ${_version} (from type '${_type}') of this software!`
          );
          setStatusSeverity("success");
          setShowStatus(true);
          getSoftware();
          setTimeout(() => {
            setShowStatus(false);
          }, 5000);
          return data.success;
        } else {
          setStatusMsg(data.reason);
          setStatusSeverity("error");
          setShowStatus(true);
          setTimeout(() => {
            setShowStatus(false);
          }, 5000);
        }
      });
  };
  const removeSoftwareVersionAccess = async (
    _softwareID: string,
    _type: string,
    _version: string,
    _username: string
  ) => {
    console.log(
      `Setting access to following version: ${_softwareID}:${_type}:${_version}`
    );
    fetch("/api/v1/software/type/version/access/remove", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        software: _softwareID,
        type: _type,
        version: _version,
        username: _username,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.success === true) {
          setStatusMsg(
            `Access removed to user ${_username} for the version ${_version} (from type '${_type}') of this software!`
          );
          setStatusSeverity("success");
          setShowStatus(true);
          getSoftware();
          setTimeout(() => {
            setShowStatus(false);
          }, 5000);
          return data.success;
        } else {
          setStatusMsg(data.reason);
          setStatusSeverity("error");
          setShowStatus(true);
          setTimeout(() => {
            setShowStatus(false);
          }, 5000);
        }
      });
  };
  const editSoftware = async (
    _id: string,
    _name: string,
    _description: string,
    _logo: string,
    _owners: any,
    _editors: any
  ) => {
    let _ownersToSend: { type: "user" | "org"; id: string }[] = [];
    let _editorsToSend: Array<string> = [];

    _ownersToSend = _owners
      .filter((value: any) => value.checked)
      .map((value: any) => {
        return { type: value.type, id: value.value };
      });

    _editorsToSend = _editors
      .filter((value: any) => value.checked)
      .map((value: any) => {
        return value.value;
      });

    console.log(`Editing software ${_id}`);
    fetch("/api/v1/software/edit", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: _id,
        logo: _logo,
        name: _name,
        description: _description ? _description : " ",
        categories: categories
          .filter((category) => category.checked)
          .map((category) => {
            return category.value;
          }),
        owners: _ownersToSend,
        editors: _editorsToSend,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.success === true) {
          setStatusMsg(`Changes to '${_name}' were saved!`);
          setStatusSeverity("success");
          setShowStatus(true);
          getSoftware();
          setTimeout(() => {
            setShowStatus(false);
          }, 5000);
          return data.success;
        } else {
          setStatusMsg(data.reason);
          setStatusSeverity("error");
          setShowStatus(true);
          setTimeout(() => {
            setShowStatus(false);
          }, 5000);
        }
      });
  };

  const deleteSoftwareVersion = async (
    _softwareID: string,
    _type: string,
    _version: string
  ) => {
    console.log(
      `Removing following version: ${_softwareID}:${_type}:${_version}`
    );
    fetch("/api/v1/software/type/version/remove", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        software: _softwareID,
        type: _type,
        version: _version,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.success === true) {
          setStatusMsg(
            `Version ${_version} (from type '${_type}') was deleted!`
          );
          setStatusSeverity("success");
          setShowStatus(true);
          getSoftware();
          setTimeout(() => {
            setShowStatus(false);
          }, 5000);
          return data.success;
        } else throw new Error(data.reason);
      });
  };

  const getPossibleOwnerList = async (toSetOwners: any) => {
    return new Promise<void>((resolve, reject) => {
      fetch("/api/v1/software/getCreationProperties", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          if (data.success === true) {
            console.log("Got possible owner list!");

            let newOwnerList = data.possibleOwnerList.map((val: any) => {
              //Check if the is owner already. If so, check it on GUI
              const tmpFilter = toSetOwners.filter(
                (x: any) => x.value === val.id
              );
              return {
                label: val.name,
                type: val.type,
                value: val.id,
                checked: tmpFilter.length > 0 ? true : false,
              };
            });

            setOwners(newOwnerList);
            return resolve();
          }
          return reject();
        });
    });
  };
  useEffect(() => {
    getSoftware();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      {
        !showActivationCodes ?

          <>
            <Title>
              View Software
              <Button
                onClick={() => {
                  editSoftware(
                    software.id,
                    software.name,
                    software.description,
                    software.logo,

                    owners,
                    editors
                  );
                  // navigate(process.env.PUBLIC_URL + "/Softwares");
                }}
              >
                Save changes
              </Button>
            </Title>

            <Content>
              <ContentTitle>{software.id}</ContentTitle>

              <ContentBody>
                <span
                  style={{
                    display: "flex",
                    whiteSpace: "nowrap",
                    width: "50rem",
                    height: "6rem",
                    position: "absolute",
                    top: "10%",
                  }}
                >
                  <ContentInput
                    label="Name"
                    variant="standard"
                    value={software.name}
                    onChange={(ev) => changeVar("name", ev.target.value)}
                  />

                  <ContentInput
                    sx={{ marginLeft: "15px", maxHeight: "3rem", width: "25rem" }}
                    id="standard-multiline-static"
                    label="Description"
                    multiline
                    rows={4}
                    variant="standard"
                    value={software.description}
                    onChange={(ev) => changeVar("description", ev.target.value)}
                  />
                </span>

                <span style={{ position: "absolute", bottom: "50%" }}>
                  <CustomSelection
                    title="Categories"
                    value={categories}
                    setValue={setCategories}
                  />
                  {/*<CustomSelection
                            title="Authorized users"
                            value={allowedUsers}
                            inputText
                            />
                        <br />*/}
                </span>
                <span
                  style={{
                    display: "flex",
                    whiteSpace: "nowrap",
                    width: "50rem",
                    height: "5rem",
                    position: "absolute",
                    bottom: "35%",
                  }}
                >
                  <CustomSelection
                    title="Who can edit?"
                    value={editors}
                    setValue={setEditors}
                  />
                  <CustomSelection
                    title="Owners"
                    value={owners}
                    setValue={setOwners}
                  />
                </span>

                <VersionList
                  container
                  spacing={1}
                  style={{
                    height: "11rem",
                  }}
                >
                  {versions.map((value, index) => (
                    <VersionContainer item xs={12} key={`soft_${value.type}_${value.version}`}>
                      <Icon src={software.logo} />
                      <VersionTitle>
                        {value.type} - {value.version}
                      </VersionTitle>
                      <Version>
                        {value.description !== "" && value.description !== " "
                          ? `Description: ${value.description}`
                          : "No description"}
                      </Version>
                      <VersionRight>
                        <CodeIcon
                          onClick={() => {
                            setSelectedVersion({
                              type: value.type,
                              version: value.version,
                            });
                            setShowActivationCodes(true);
                          }}
                        >
                          <VpnKey />
                          Activation Codes
                        </CodeIcon>
                        <SoftwareIcon
                          value={["Public", "Owners", "Restrict"].map(
                            (value2: string) => {
                              return {
                                label: value2,
                                checked: value2 === value.accessType,
                              };
                            }
                          )}
                          onItemCheckedChange={(
                            acessType: string,
                            checkedStatus: boolean
                          ) => {
                            console.log(
                              `Setting acess type ${acessType} access to the selected version`
                            );
                            setSoftwareAccessType(
                              software.id,
                              value.type,
                              value.version,
                              acessType
                            );
                          }}
                        />
                        {value.accessType === "Restrict" && (
                          <UsersIcon
                            value={value.allowedUsers.map((value2: any) => {
                              return {
                                label: value2.username,
                                checked: value2.canAccess,
                              };
                            })}
                            onItemCheckedChange={(
                              username: string,
                              checkedStatus: boolean
                            ) => {
                              if (checkedStatus === false) {
                                console.log(
                                  `Removing user ${username} access to the selected version`
                                );
                                removeSoftwareVersionAccess(
                                  software.id,
                                  value.type,
                                  value.version,
                                  username
                                );
                              } else if (checkedStatus === true) {
                                console.log(
                                  `Adding user ${username} access to the selected version`
                                );
                                addSoftwareVersionAccess(
                                  software.id,
                                  value.type,
                                  value.version,
                                  username
                                );
                              }
                            }}
                          />
                        )}
                        {deleteVersion !== index ? (
                          <DeleteIcon onClick={() => setDeleteVersion(index)} />
                        ) : (
                          <DeletePrompt show>
                            Delete?{" "}
                            <DeletePromptYes
                              onClick={() => {
                                setDeleteVersion(-1);
                                deleteSoftwareVersion(
                                  software.id,
                                  value.type,
                                  value.version
                                );
                              }}
                            />{" "}
                            <DeletePromptNo onClick={() => setDeleteVersion(-1)} />
                          </DeletePrompt>
                        )}
                      </VersionRight>
                    </VersionContainer>
                  ))}
                </VersionList>

                <ContentInputProfilePhoto onClick={onImageChangeClick}>
                  <img
                    src={software.logo}
                    alt="Click here to upload the software logo"
                    style={{
                      width: "10rem",
                      height: "10rem",
                    }}
                  />
                  <ContentInputProfilePhotoIcon />

                  <input
                    type="file"
                    ref={hiddenLogoInput}
                    onChange={onHiddenLogoInputChange}
                    style={{ display: "none" }}
                  />
                </ContentInputProfilePhoto>
              </ContentBody>
            </Content>

            <Snackbar
              open={showStatus}
              autoHideDuration={6000}
              onClose={handleCloseStatus}
            >
              <Alert
                onClose={handleCloseStatus}
                severity={statusSeverity}
                sx={{ width: "100%" }}
              >
                {statusMsg}
              </Alert>
            </Snackbar>
          </>
          :
          <>
            <Title>
              View Software - {softwareID} {selectedVersion?.type} {selectedVersion?.version}
              <BackButton
                onClick={() => {
                  setShowActivationCodes(false);
                }}
              >
                <ArrowBack />
              </BackButton>
            </Title>

            <ContentBody>
              <ActivationCodesView id={softwareID || ""} type={selectedVersion?.type || ""} version={selectedVersion?.version || ""} />
            </ContentBody>
          </>
      }
    </Container>
  );
};

export default ViewPatients;
